import React, { useEffect, useState } from 'react'
import { FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom'
import Icocnrc from './mi_icono';
import { footerSocial } from '../data';
import { LuPhone } from 'react-icons/lu';

export default function Navbar({navLight, bg}) {
    let [toggle, setToggle] = useState(false);
    let [manu, setManu] = useState();
    let [submenu, setSubManu] = useState();
    let [scrolling, setScrolling] = useState(false);
    let [textClass, setTextClass] = useState("text-light")
    const isMobile = window.innerWidth <= 768; // Puedes ajustar este valor de acuerdo a tu diseño

    let current = window.location.pathname

    

    useEffect(()=>{
        setManu(current);
        setSubManu(current) 
        window.scrollTo(0, 0);
       

      const handleScroll = () => {
        const isScrolling = window.scrollY > 50; // O el valor que prefieras
        setScrolling(isScrolling);

        // Lógica para cambiar la clase del texto
        if (window.scrollY < 50 & !isMobile ) {
            setTextClass("text-light");
        }else if(!isMobile){
            setTextClass("text-light")
        } 
    };
        
        window.addEventListener('scroll', handleScroll);
        

        return()=>{
            window.removeEventListener('scroll', handleScroll);
            
        }
        
    },[current])

  return (
        <header id="topnav" className={`defaultscroll sticky ${scrolling ? 'nav-sticky' : ''} ${bg ? 'bg-light' : ''}`}>
            <div className={`pix-topbar pix-header-mobile pix-topbar-normal ${isMobile ? 'bg-dark text-white ' : ''} ${scrolling ? 'bg-dark text-white' : ''} p-sticky py-22`}>
                <div className='container'>
                <div className='row'>
                    <div className='col-12 column d-flex justify-content-between py-md-02 pix-py-10'>
                               <ul className="list-unstyled text-sm-start social-icon social mb-0">
                                               {footerSocial.map((item,index)=>{
                                                   let Icon = item.icon
                                                   return(
                                                       <li className="list-inline-item m-x-2" key={index}><Link className="rounded" to={item.link} target='_blank' style={{border:0}}><i className=" align-middle"><Icon className={`${textClass}`}/></i></Link></li>
                                                   )
                                               })}
                                           </ul>
                                           <div className={`mt-2 ${textClass}`} style={{fontSize:12}}><LuPhone style={{fontSize:15}} /> &nbsp; +52 1 662 360 4491</div>
                    </div>
                 </div>    
                </div>
            </div>
            
            <div className="container">
                 <Link className="logo" to="/" style={{color:'#6dc77a'}}> 
                     <Icocnrc size={40} color={'#6dc77a'} /> CNRC
                    </Link>     

                <div className="menu-extras">
                    <div className="menu-item">
                        <Link to="#" className={`navbar-toggle ${toggle ? 'open' : ''}`} id="isToggle" onClick={(e)=>{setToggle(!toggle)}}>
                            <div className="lines">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </Link>
                    </div>
                </div>  

                 <div className="buy-button">
                    <Link to="https://wa.me/+5216623604491?text=Información CNRC"  target='_blank'>
                        <span className="btn btn-primary d-md-inline-flex d-none">Whatsapp &nbsp; <FaWhatsapp className="fea icon-sm"/></span>                        
                    </Link>
                     <Link to="https://wa.me/+5216623604491?text=Información CNRC"  target='_blank' className='whatsapp_float'>
                        <FaWhatsapp className="whatsapp-icon"/>                        
                    </Link>
                </div>

                <div className='wa__btn_popup_txt ayuda_whatsapp'>
                    <span>¿Necesitas ayuda? <br />
                        <strong>¡Chatea con nosotros!</strong>
                    </span>
                </div>
         
        
                <div id="navigation" style={{display : toggle ? 'block' : 'none'}}>
                    <ul className={`navigation-menu nav-right nav-light`}>
                        <li className={`${manu === '/' ? 'active' : ''}`}><Link to="/" className="sub-menu-item" >Inicio</Link></li>                   
                               

                        <li className={`has-submenu parent-menu-item ${['/page-tratamos','/depresion','/ansiedad','/tdah','/trastornobipolar','/trastornosueno','/toc','/trastornopanico','/estrespostraumatico','/abusodesustancias','/esquizofrenia'].includes(manu) ? 'active' : ''}`}>
                            <Link to="#" onClick={()=>setSubManu(submenu === '/page-tratamos' ? '' : '/page-tratamos' )} style={{textTransform:'none'}} >Lo que tratamos</Link><span className="menu-arrow"></span>
                            <ul className={`submenu ${['/page-tratamos','/depresion','/ansiedad','/tdah','/trastornobipolar','/trastornosueno','/toc','/trastornopanico','/estrespostraumatico','/abusodesustancias','/esquizofrenia' ].includes(submenu) ? 'open' : ''}`}>
                                <li className={`${manu === '/depresion' ? 'active' : ''}`}><Link to="/depresion" className="sub-menu-item" style={{textTransform:'none'}}>Depresión</Link></li>
                                <li className={`${manu === '/ansiedad' ? 'active' : ''}`}><Link to="/ansiedad" className="sub-menu-item" style={{textTransform:'none'}}>Ansiedad</Link></li>
                                <li className={`${manu === '/tdah' ? 'active' : ''}`}><Link to="/tdah" className="sub-menu-item" style={{textTransform:'none'}}>TDAH</Link></li>
                                <li className={`${manu === '/trastornobipolar' ? 'active' : ''}`}><Link to="/trastornobipolar" className="sub-menu-item" style={{textTransform:'none'}}>Trastorno bipolar</Link></li>
                                <li className={`${manu === '/trastornosueno' ? 'active' : ''}`}><Link to="/trastornosueno" className="sub-menu-item" style={{textTransform:'none'}}>Trastorno del sueño</Link></li>
                                <li className={`${manu === '/toc' ? 'active' : ''}`}><Link to="/toc" className="sub-menu-item" style={{textTransform:'none'}}>TOC</Link></li>
                                <li className={`${manu === '/trastornopanico' ? 'active' : ''}`}><Link to="/trastornopanico" className="sub-menu-item" style={{textTransform:'none'}}>Trastorno de pánico</Link></li>
                                <li className={`${manu === '/estrespostraumatico' ? 'active' : ''}`}><Link to="/estrespostraumatico" className="sub-menu-item" style={{textTransform:'none'}}>Trauma y trastorno de estrés postraumático</Link></li>
                                <li className={`${manu === '/abusodesustancias' ? 'active' : ''}`}><Link to="/abusodesustancias" className="sub-menu-item" style={{textTransform:'none'}}>Abuso de sustancias</Link></li>
                                <li className={`${manu === '/esquizofrenia' ? 'active' : ''}`}><Link to="/esquizofrenia" className="sub-menu-item" style={{textTransform:'none'}}>Esquizofrenía</Link></li>                                
                            </ul>
                        </li>

                  <li className={`has-submenu parent-menu-item ${['/page-servicios','/emt','/dcs','/rehacom'].includes(manu) ? 'active' : ''}`}>
                            <Link to="#" onClick={()=>setSubManu(submenu === '/page-servicios' ? '' : '/page-servicios' )} style={{textTransform:'none'}} >Servicios</Link><span className="menu-arrow"></span>
                            <ul className={`submenu ${['/page-servicios','/emt','/dcs','/rehacom'].includes(submenu) ? 'open' : ''}`}>
                                <li className={`${manu === '/emt' ? 'active' : ''}`}><Link to="/emt" className="sub-menu-item" style={{textTransform:'none'}}>EMTr o rTMS</Link></li>
                                <li className={`${manu === '/dcs' ? 'active' : ''}`}><Link to="/dcs" className="sub-menu-item" style={{textTransform:'none'}}>tDCS</Link></li>                              
                                <li className={`${manu === '/rehacom' ? 'active' : ''}`}><Link to="/rehacom" className="sub-menu-item" style={{textTransform:'none'}}>RehaCom</Link></li>                              
                            </ul>
                        </li>

                   <li className={`${manu === '/nosotros' ? 'active' : ''}`}><Link style={{textTransform:'none'}} to="/nosotros" className="sub-menu-item">Nosotros</Link></li>

                    <li className={`${manu === '/contacto' ? 'active' : ''}`}><Link  style={{textTransform:'none'}} to="/contacto" className="sub-menu-item">Contacto</Link></li>
                    </ul>
                </div>
            </div>
        </header>
  )
}
